import React from "react";
import { Container, Row } from "react-bootstrap";
import "./LactationConsult.scss";
import In_person_lactation from "../../../Assets/img/service/in-person-lactation.png";
import Virtual_consultation from "../../../Assets/img/service/virtual-lactation.png";
import prenatalLactationConsultation from "../../../Assets/img/service/prenatalLactationConsultation.jpg";
import {
  PRENATAL_REMOTE_LACTATION_URL,
  REMOTE_LACTATION_URL,
  VIRTUAL_REMOTE_LACTATION_URL,
} from "../../../Utils/ServiceUrl";
import { useNavigate } from "react-router-dom";
import trueSupportHero from "../../../Assets/img/janellecarmela-270.jpg";
import StreetCred from "../../../Common/streetCred/streetCred";
import LandingDescription from "../../../Common/LandingDescription";
import hero from "../../../Assets/img/service/lactation.png";
import PinkContentBox from "../../../Common/PinkContentBox";
import Accordion from "../../../Common/Accordion/Accordion";

const LactationConsult = () => {
  const Navigate = useNavigate();

  let testimonialData = [
    {
      name: "Alyssa S.",
      data: "“I had a zoom lactation consult today with NAPSand it was beyond helpful! The lactation consultant was full of great advice and listened to my concerns with an open mind. She made me feel both heard and validated. I left our session with new strategies to try with regards to feeding and my infants sleep patterns, and an overall better feeling about being a first time mom. This support and professional guidance was exactly what I needed right now and I plan on meeting with her again in the future.",
    },
    {
      name: "Tricia G.",
      data: "I can't give enough praise to our NAPS lactation consultant, Nicole. Nicole met with us the day after we got home from the hospital with our first baby, and helped us with breast feeding, bottle feeding (w/ formula), and pumping. Nicole is kind, supportive, non-judgmental, and full of tips and wisdom. Nicole is also extremely perceptive, and worked with our pediatrician directly to share her concerns about a medical issue with our daughter -- without her intervention, it would have been weeks before we were able to diagnose her. Thanks to Nicole we've had a successful feeding journey with our daughter and are so grateful! We're excited to continue to work with Nicole and NAPS as our daughter gets older and we work on a weaning plan!",
    },
  ];
  return (
    <div className="Lactationconsult-main">
      <Container fluid>
        <div
          className="lactationHero py-3"
          style={{
            backgroundImage: `url(${hero})`,
          }}
        >
          <div className="lactationHeroContent">
            <h1 className="lactationHeroTitle">
              <div style={{ color: "#30426D" }}>Lactation Support</div>
              <div className="strong" style={{ color: "#30426D" }}>
                that’s actually supportive{" "}
              </div>
            </h1>
            <p className="lactationHeroSubtle short-description">
              In-home & Virtual Lactation Support that’s actually supportive
            </p>
            <a
              className="btn primary-blue-small-btn-40 lactationHeroCTA"
              href="https://www.nurturebynaps.com/private-class2"
            >
              Check Your Eligibility
            </a>
          </div>
        </div>

        <LandingDescription
          ySpace
          content={[
            <>
              We are a team of Registered Nurses who are also IBCLC Lactation
              Consultants – this isn’t the norm everywhere. We use our expertise
              to build the right feeding journey{" "}
              <i className="strong">for you.</i>{" "}
              We work with many insurance providers to make your care as accessible as possible. <a
                  href="https://www.nurturebynaps.com/private-class2"
                  className="strong"
              >Request a consult,</a>{" "}
              and we’ll handle the coverage check and get you scheduled quickly so you can start getting the support you need.
            </>,
          ]}
        />

        <PinkContentBox
          imgSrc={trueSupportHero}
          title={
            <>
              <div className="strong">Support without judgment</div>
            </>
          }
          paragraph={
            <>
              Whether you’re breastfeeding, pumping, formula feeding, or a
              combination of all three, we’re here to help. As Registered
              Nurses, we understand that{" "}
              <span className="strong">Fed Is Best</span> and have helped over
              10,000 families reach their feeding goals.
            </>
          }
          btnClick={() => Navigate(REMOTE_LACTATION_URL)}
          btnText="Book now"
        />

        <Row className="pale-bg offering-main pb-4">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <Container>
              <Row className="justify-content-center my-5">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="section-header text-center">
                    <h2 className="home-section-title py-0">
                      Our
                      <span className="strong pink"> Offerings</span>
                    </h2>
                    <p className="">
                      <a href="https://www.nurturebynaps.com/private-class2">
                        Check your eligibility
                      </a>{" "}
                      for insurance-covered care.
                    </p>
                    <h4
                      className="text-center home-section-description mt-2 mx-auto"
                      style={{ maxWidth: "600px" }}
                    >
                      Address any feeding concerns, learn about different
                      positions to feed your baby, and build a feeding schedule
                      that works for your family.
                    </h4>
                  </div>
                </div>
              </Row>

              <Row className="justify-content-center align-items-center mt-5">
                <div className="col-lg-5 col-md-5 col-sm-12 order-1 order-md-0 mt-4 mt-md-0">
                  <div className="offering-block-content me-0 me-md-5">
                    <h3 className="lh-1 w-100 ">
                      <span className="offer-number">1. </span>
                      Prenatal Lactation Consultation
                    </h3>
                    <p>
                      Meet 1:1 with an RN and IBCLC during your pregnancy to talk
                      through your feeding goals and how we can support you from
                      day one. We’ll help you choose and set up your breast
                      pump, discuss common feeding challenges, and make a plan
                      for partner support (just to name a few)!
                    </p>
                    <button
                      className="w-auto btn-small teal-btn-small"
                      onClick={() => Navigate(PRENATAL_REMOTE_LACTATION_URL)}
                    >
                      Learn More
                    </button>
                  </div>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 order-0 order-md-1">
                  <div className="service-feature-img">
                    <img
                      src={prenatalLactationConsultation}
                      className="img-fluid"
                      alt="Prenatal Lactation Consultation"
                    />
                  </div>
                </div>
              </Row>

              <Row className="justify-content-center align-items-center my-5">
                <div className="col-lg-5 col-md-5 col-sm-12">
                  <div className="service-feature-img me-0 me-md-5">
                    <img
                      src={In_person_lactation}
                      className="img-fluid"
                      alt="In-Home Lactation Consultation"
                    />
                  </div>
                </div>

                <div className="col-lg-5 col-md-5 col-sm-12 mt-4 mt-md-0">
                  <div className="offering-block-content ">
                    <h3 className="lh-1 w-100">
                      <span className="offer-number">2. </span>
                      In-Home Lactation Consultation
                    </h3>
                    <p>
                      For MA residents only. Meet 1:1 in your home with an RN
                      and IBCLC. Address any feeding concerns or questions
                      regardless of how small or big the issue, or how you are
                      choosing to feed your baby.
                    </p>
                    <button
                      className="w-auto btn-small teal-btn-small"
                      onClick={() => Navigate(REMOTE_LACTATION_URL)}
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </Row>

              <Row className="justify-content-center align-items-center mt-5">
                <div className="col-lg-5 col-md-5 col-sm-12 order-1 order-md-0 mt-4 mt-md-0">
                  <div className="offering-block-content me-0 me-md-5">
                    <h3 className="lh-1 w-100 ">
                      <span className="offer-number">3. </span>
                      Virtual Lactation Consultation
                    </h3>
                    <p>
                      Meet 1:1 with an RN and IBCLC during this telehealth
                      appointment. Address any feeding concerns or questions
                      regardless of how small or big the issue. These consults
                      can be scheduled with our consultant regardless of where
                      you live.
                    </p>
                    <button
                      className="w-auto btn-small teal-btn-small"
                      onClick={() => Navigate(VIRTUAL_REMOTE_LACTATION_URL)}
                    >
                      Learn More
                    </button>
                  </div>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12 order-0 order-md-1">
                  <div className="service-feature-img">
                    <img
                      src={Virtual_consultation}
                      className="img-fluid"
                      alt="Virtual Lactation Consultation"
                    />
                  </div>
                </div>
              </Row>
            </Container>
          </div>
        </Row>

        <StreetCred
          data={testimonialData}
          description="Still not convinced? Check out what parents like you are saying."
          title={
            <>
              180+ <span className="strong">5 star reviews</span>
            </>
          }
        />

        <Row className="pale-bg py-5 px-3">
          <div className="lactationAccordion">
            <h3 className="lactationAccordionTitle">
              Frequently Asked Questions
            </h3>
            {faqs.map(({ title, description }, i: number, arr) => (
              <Accordion
                title={title}
                description={description}
                bottomBorder={i !== arr.length - 1}
              />
            ))}
          </div>
        </Row>
      </Container>
    </div>
  );
};

const faqs = [
  {
    title: "How are you different from other Lactation Consultants?",
    description: (
      <>
        We are Registered Nurses and IBCLCs. While both CLCs and IBCLCs provide
        lactation support, IBCLCs have a higher level of training,
        certification, and expertise. As Registered Nurses, we are able to
        address a broader range of lactation issues and extend beyond feeding
        into sleep, solids, and more.
      </>
    ),
  },
  {
    title: "Does my insurance cover this consultation?",
    description: (
      <>
        We accept many insurance options including BCBS, United Healthcare,
        Cigna, MGB, and more.{" "}
        <a
          href="https://www.nurturebynaps.com/private-class2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here to check your eligibility
        </a>
        . If you are covered through insurance, there is no cost to you with the
        exception of a $40 travel fee for all in-home consultations. You are
        also responsible for providing parking for the lactation consultant. If
        there is no free parking option, you’ll be charged for any parking costs
        they incur.
      </>
    ),
  },
  {
    title: "What if my insurance doesn’t cover it?",
    description: (
      <>
        You can pay out of pocket for our services. If you have an FSA or HSA
        account, you can use those funds too. If paying out of pocket, our
        in-home consults are $349 for an initial appointment (2 hours), and $325
        for follow-up appointments (1.5 hours). For virtual consults, the fee is
        $325 for both initial and follow-up appointments (1.5 hours).{" "}
        <a
          href="https://www.nurturebynaps.com/private-class2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Check Your Eligibility
        </a>{" "}
        for insurance-covered care. If not
        approved, we can provide a superbill for you to submit to your insurance
        company directly for reimbursement.
      </>
    ),
  },
  {
    title: "How long is the wait time for an appointment?",
    description: (
      <>
        Upon receiving your request, we will respond within 24 hours
        Monday–Friday, or within 48 hours on weekends. Appointments are
        typically scheduled within 1-3 days for virtual consults and 2–7 days
        for in-home consultations.
      </>
    ),
  },
  {
    title: "What can I expect during the consultation?",
    description: (
      <>
        We start by addressing your immediate needs and concerns, however you're
        choosing to feed your baby. We listen first, hear about your struggles
        and goals, observe a feeding session, and then provide advice, feedback,
        and a care plan based on your input and our observations.
      </>
    ),
  },
  {
    title: "Where does the consultation take place?",
    description: (
      <>
        We offer in-home consultations to patients in Massachusetts, and virtual
        consultations via our secure telehealth platform to patients in any
        state.
      </>
    ),
  },
  {
    title: "What if I’m thinking about switching to only formula feeding?",
    description: (
      <>
        From the beginning, we’ve supported families no matter what feeding path
        they choose. If you're thinking of switching to formula only, we can
        help you create a plan to wean and transition your baby smoothly. We're
        here to support you—whether it’s breastfeeding, pumping, or formula.
      </>
    ),
  },
];

export default LactationConsult;
